module.exports = __webpack_public_path__ + "media/site_templates/www.localgardeners.com.au/images/feature_1-7a3b47fe06ffce60190f2c5bada916fc.jpeg";